const ADMIN_BASE = '/admin';

export const ADMIN_AUDIT_LOGS_PATH = `${ADMIN_BASE}/audit-logs`;

/**
 * Only GALLERY_ADMINS have access to this page. It is currently hardcoded
 */
export const ADMIN_FULLY_CONNECTED_PATH = `${ADMIN_BASE}/fully-connected`;

export const ADMIN_GLUE_PATH = `${ADMIN_BASE}/glue`;
export const ADMIN_HOME_PATH = `${ADMIN_BASE}/home`;

export const ADMIN_ORGANIZATION_PATHS = [
  `${ADMIN_BASE}/organization`,
  `${ADMIN_BASE}/organizations`,
];
export const ADMIN_RAMP_PATH = `${ADMIN_BASE}/ramp`;
export const ADMIN_USERS_PATH = `${ADMIN_BASE}/users`;
